import { render, staticRenderFns } from "./TheResultCampaignAdvice.vue?vue&type=template&id=5790b210&"
import script from "./TheResultCampaignAdvice.vue?vue&type=script&lang=js&"
export * from "./TheResultCampaignAdvice.vue?vue&type=script&lang=js&"
import style0 from "./TheResultCampaignAdvice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports